export const board = [
  {
    name: "Ashif Shaikh",
    description: (
      <>
        <p>
          Recipient of the Social Innovator of the Year 2020 by World Economic
          Forum, and more recently the Gleitsman International Activist Award
          2022 by Harvard University&apos;s Center for Public Leadership. Ashif
          is recognized as a credible initiative builder by civil society,
          government and, industry leaders.
        </p>
      </>
    ),
    image: "/images/team/aashif.webp",
    designation: "",
  },
  // {
  //   name: "Derek Mitchell ",
  //   description: (
  //     <>
  //       <p>
  //         Director of the Unitarian Universalist Holdeen India Program (UUHIP)
  //         from August 2011. Derek brings with him a spiritual and philosophical
  //         understanding of the complexities surrounding social change in India.
  //       </p>
  //     </>
  //   ),
  //   image: "/images/team/derek.png",
  //   designation: "",
  // },
  // {
  //   name: "Jamuna Ramakrishna",
  //   description: (
  //     <>
  //       <p>
  //         Currently an independent consultant, she works to facilitate
  //         organisational learning processes, management of non-profit
  //         organisations and documentation, analysis and synthesis.
  //       </p>
  //     </>
  //   ),
  //   image: "/images/product-list.svg",
  //   designation: "",
  // },
  {
    name: "Shalini Nataraj",
    description: (
      <>
        <p>
          Currently Vice President of Programs with the Ing Foundation. She has
          experience working on human rights issues, with a specific focus on
          women&apos;s rights and addressing societal inequalities with a
          feminist lens.
        </p>
      </>
    ),
    image: "/images/team/Board member Shalini Nataraj.jpg",
    designation: "",
  },
  {
    name: "Shikha Bhattacharjee",
    description: (
      <>
        <p>
          Research Fellow at the Zolberg Institute on Migration and Mobility.
          Shikha&apos;s research and writing take an interdisciplinary and
          transnational perspective in understanding labour markets, migration,
          and variegated citizenship.
        </p>
      </>
    ),
    image: "/images/team/Shika.jpeg",
    designation: "",
  },
];
